export const getEventNameByTabValue = (tabName: string) => {
  switch (tabName) {
    case 'psa':
      return 'Menu_Operations_Click';
    case 'analytics':
      return 'Menu_Analitics_Click';
    case 'user-list':
      return 'Menu_Users_Click';
    case 'pzu':
      return 'Menu_Pzu_Click';
    case 'prices':
      return 'Menu_Price_Click';
    case 'info':
      return 'Menu_Information_Click';
    case 'risk-manegment':
      return 'Menu_RiskManagment_Click';
    case 'help':
      return 'Menu_Help_Click';
    case 'news':
      return 'Menu_News_Click';
    case 'lz':
      return 'Menu_Lz_Click';
    case 'ls':
      return 'Menu_Ls_Click';
    case 'transaction':
      return 'Menu_Transaction_Click';
    default:
      return '';
  }
};

export const eventMap: Record<string, string> = {
  'Акты': 'Menu_Operations_Psa_Click',
  'Платежи': 'Menu_Operations_Payments_Click',
};

export const createPsaEventMap: Record<string, string> = {
  'pzu': 'PsaCreateStep1_Pzu_Error',
  'name': 'PsaCreateStep1_Ls_Error',
  'classifierCode': 'PsaCreateStep1_TypeOfMetal_Error',
  'paymentMethod': 'PsaCreateStep1_TypeOfPayment_Error',
};

export const lzClientErrorEvents: Record<string, string> = {
  'fullName': 'LsCreate_FullName_Error',
  'citizenshipNewLzForm': 'LsCreate_Citizen_Error',
  'birthday': 'LsCreate_DateOfBith_Error',
  'passportSnNewLzForm': 'LsCreate_PassportId_Error',
  'passportIssueDate': 'LsCreate_IssuedAt_Error',
  'address': 'LsCreate_Adress_Error',
  'inn': 'LsCreate_Inn_Error',
};
